import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Onefourseaterurbania() {



  const cardData = {
"keyword": "14 Seater Urbania on Rent in Pune",

"headingDescription":
  "Aaradhya Travels offers premium 14 Seater Urbania on Rent in Pune for weddings, family trips, corporate travel, airport transfers, outstation tours, business meetings, and luxury group transportation requirements. Our 14-seater Force Urbania vehicles feature comfortable pushback seats, air-conditioning, spacious interiors, luggage space, charging points, music systems, and experienced drivers familiar with Pune city roads and highways. We ensure safe, comfortable, and punctual travel with doorstep pickup services for local and outstation journeys across Pune.",

"topPlaces": [

{
"title": "Imagicaa Theme Park",
"description":
"Imagicaa is a large theme park near Mumbai offering rides, entertainment zones, and water parks. It is a popular destination for school trips, corporate outings, and family group tours."
},
  {
"title": "Mumbai",
"description":
"Mumbai is the financial capital of India known for Marine Drive, Gateway of India, Juhu Beach, Bollywood, shopping streets, and vibrant city life. It is one of the most popular group travel destinations from Pune for corporate tours, shopping trips, and leisure outings."
},
{
"title": "Matheran",
"description":
"Matheran is Asia’s only automobile-free hill station near Mumbai known for toy train rides, viewpoints, dense greenery, and cool weather. It is a peaceful weekend getaway for families and group travelers from Pune and Mumbai."
},
{
"title": "Alibaug",
"description":
"Alibaug is a coastal beach destination near Mumbai known for clean beaches, sea forts, water sports, and relaxed seaside atmosphere. It is a popular group tour destination for short trips from Pune."
},
{
"title": "Lonavala",
"description":
"Lonavala is a famous hill station near Mumbai and Pune known for waterfalls, caves, green valleys, and monsoon beauty. It is a highly visited weekend destination for group bus and Tempo Traveller trips."
},
{
"title": "Khandala",
"description":
"Khandala is known for scenic valleys, misty hills, and natural viewpoints. It is a short and relaxing getaway destination popular among families and group travelers from Mumbai and Pune."
},
{
"title": "Navi Mumbai",
"description":
"Navi Mumbai is a planned city known for clean infrastructure, parks, malls, and business hubs. It is commonly visited for corporate group travel, events, and city tours."
},
{
"title": "Elephanta Caves",
"description":
"Elephanta Caves are UNESCO World Heritage rock-cut caves located on an island near Mumbai known for ancient sculptures and historical significance. It is a popular heritage group tour destination."
},

{
"title": "Karjat",
"description":
"Karjat is a scenic green valley near Mumbai known for waterfalls, rivers, resorts, and adventure activities. It is widely chosen for weekend group trips and corporate outings."
},
{
"title": "Khopoli",
"description":
"Khopoli is known for industrial areas, waterfalls nearby, and proximity to Imagicaa theme park. It is a convenient stopover destination for group travel between Pune and Mumbai."
}
],



services: [
  {
    name: "14 Seater Urbania Traveller Pune",
    description: "14 seater Urbania traveller Pune service provides luxury transportation for family vacations, airport transfers, sightseeing tours, and group travel requirements. Spacious seating and premium interiors ensure comfortable journeys suitable for medium-sized passenger groups. Professional chauffeurs ensure dependable transportation and safe driving services throughout the route. Pickup services are available from homes, offices, hotels, airports, and residential areas across Pune. Flexible booking options allow convenient 14 seater Urbania traveller reservations."
  },
  {
    name: "14 Seater Urbania Hire in Pune",
    description: "14 seater Urbania hire in Pune service offers spacious transportation for weddings, business travel, office outings, and tourist journeys. Comfortable seating and smooth travel ensure pleasant journeys suitable for local and outstation passenger movement. Professional drivers ensure punctual transportation and safe driving services throughout the route. Pickup services are available from homes, offices, hotels, and railway stations across Pune. Flexible booking options allow convenient 14 seater Urbania hire reservations."
  },
  {
    name: "14 Seater Urbania Booking Pune",
    description: "14 seater Urbania booking Pune service provides dependable transportation for educational tours, family group travel, sightseeing trips, and airport transfers. Spacious seating and luggage capacity ensure comfortable journeys suitable for medium-sized passenger groups. Professional chauffeurs ensure safe transportation and reliable pickup services throughout the route. Pickup services are available from homes, hotels, offices, and residential areas across Pune. Flexible booking options allow convenient 14 seater Urbania booking reservations."
  },
  {
    name: "14 Seater Urbania Van Rental Pune",
    description: "14 seater Urbania van rental Pune service offers reliable transportation for family outings, corporate travel, airport pickups, and wedding group transportation. Spacious interiors and comfortable seating ensure smooth journeys suitable for local and outstation travel requirements. Professional chauffeurs ensure dependable transportation and safe driving services throughout the route. Pickup services are available from homes, hotels, offices, and airports across Pune. Flexible booking options allow convenient Urbania van rental reservations."
  },
  {
    name: "Luxury 14 Seater Urbania on Rent Pune",
    description: "Luxury 14 seater Urbania on rent Pune service provides premium transportation with elegant interiors and spacious seating for weddings, corporate travel, airport transfers, and family vacations. Smooth highway travel ensures pleasant journeys suitable for executive passengers and tourist groups. Professional chauffeurs ensure dependable transportation and safe driving services throughout the route. Pickup services are available from homes, hotels, offices, and airports across Pune. Flexible booking options allow convenient luxury Urbania reservations."
  },
  {
    name: "14 Seater Urbania for Outstation Pune",
    description: "14 seater Urbania for outstation Pune service provides premium long-distance transportation for Goa tours, hill station vacations, pilgrimage journeys, and family trips. Spacious seating and smooth highway travel ensure comfortable journeys suitable for all passenger groups. Professional drivers ensure dependable transportation and safe driving services throughout the route. Pickup services are available from homes, offices, hotels, and airports across Pune. Flexible booking options allow convenient outstation Urbania reservations."
  },
  {
    name: "14 Seater Urbania Near Me Pune",
    description: "14 seater Urbania near me Pune service provides dependable transportation for family outings, airport transfers, sightseeing tours, weddings, and corporate travel. Spacious interiors and comfortable seating ensure smooth journeys suitable for local and outstation passenger movement. Professional chauffeurs ensure punctual transportation and safe driving services throughout the route. Pickup services are available from homes, offices, hotels, and residential areas across Pune. Flexible booking options allow convenient nearby Urbania rental reservations."
  },
  {
    name: "14 Seater Urbania for Family Trip Pune",
    description: "14 seater Urbania for family trip Pune service offers dependable transportation for holiday vacations, sightseeing tours, pilgrimage journeys, and family outings. Spacious seating and comfortable interiors ensure pleasant journeys suitable for local and outstation family group travel. Professional chauffeurs ensure reliable transportation and safe driving services throughout the route. Pickup services are available from homes, hotels, offices, and residential areas across Pune. Flexible booking options allow convenient family trip Urbania reservations."
  },
  {
    name: "14 Seater Urbania for Group Travel Pune",
    description: "14 seater Urbania for group travel Pune service provides spacious transportation for educational tours, sightseeing journeys, office outings, family vacations, and tourist travel. Comfortable seating and smooth travel ensure pleasant journeys suitable for medium-sized passenger groups. Professional drivers ensure dependable transportation and safe driving services throughout the route. Pickup services are available from homes, offices, hotels, airports, and residential areas across Pune. Flexible booking options allow convenient group travel Urbania reservations."
  },
  {
    name: "14 Seater Urbania on Rent Hadapsar",
    description: "14 seater Urbania on rent Hadapsar service offers reliable transportation for corporate travel, family outings, airport transfers, and group journeys. Spacious seating and smooth travel ensure pleasant journeys suitable for local and outstation transportation requirements. Professional chauffeurs ensure safe transportation and punctual pickup services throughout the route. Pickup services are available from homes, offices, hotels, and residential areas across Hadapsar Pune. Flexible booking options allow convenient Hadapsar Urbania reservations."
  },
  {
    name: "14 Seater Urbania Kharadi",
    description: "14 seater Urbania Kharadi service provides spacious transportation for corporate travel, office outings, airport transfers, and family group travel. Comfortable seating and smooth travel ensure pleasant journeys suitable for IT employees and family passengers. Professional drivers ensure safe transportation and punctual pickup services throughout the route. Pickup services are available from homes, offices, hotels, and commercial hubs across Kharadi Pune. Flexible booking options allow convenient Kharadi Urbania reservations."
  },
  {
    name: "14 Seater Urbania Viman Nagar",
    description: "14 seater Urbania Viman Nagar service provides luxury transportation for airport transfers, weddings, sightseeing tours, and family vacations. Comfortable seating and luggage space ensure pleasant journeys suitable for local and outstation travel requirements. Professional chauffeurs ensure safe transportation and dependable pickup services throughout the route. Pickup services are available from homes, hotels, airports, and residential areas across Viman Nagar Pune. Flexible booking options allow convenient Viman Nagar Urbania reservations."
  },
  {
    name: "14 Seater Urbania Swargate",
    description: "14 seater Urbania Swargate service offers comfortable transportation for family outings, office travel, airport transfers, and sightseeing journeys. Spacious seating and smooth travel ensure pleasant journeys suitable for local and outstation transportation requirements. Professional chauffeurs ensure dependable transportation and safe driving services throughout the route. Pickup services are available from homes, hotels, offices, and residential areas across Swargate Pune. Flexible booking options allow convenient Swargate Urbania reservations."
  },
  {
    name: "14 Seater Urbania Kothrud",
    description: "14 seater Urbania Kothrud service offers luxury transportation for family vacations, corporate travel, sightseeing journeys, and airport transfers. Spacious seating and premium interiors ensure smooth journeys suitable for local and outstation travel requirements. Professional chauffeurs ensure dependable transportation and safe driving services throughout the route. Pickup services are available from homes, offices, hotels, and residential areas across Kothrud Pune. Flexible booking options allow convenient Kothrud Urbania reservations."
  },
  {
    name: "14 Seater Urbania Camp Pune",
    description: "14 seater Urbania Camp Pune service provides reliable transportation for tourist travel, business meetings, airport pickups, and family outings. Comfortable seating and luggage capacity ensure smooth journeys suitable for local and intercity passenger movement. Professional chauffeurs ensure punctual transportation and safe driving services throughout the route. Pickup services are available from homes, offices, hotels, and railway stations across Camp Pune. Flexible booking options allow convenient Camp Urbania reservations."
  },
  {
    name: "14 Seater Urbania Bibwewadi",
    description: "14 seater Urbania Bibwewadi service offers dependable transportation for weddings, sightseeing tours, office travel, and family vacations. Spacious seating and modern interiors ensure comfortable journeys suitable for local and outstation passenger movement. Professional chauffeurs ensure safe transportation and dependable pickup services throughout the route. Pickup services are available from homes, offices, hotels, and residential areas across Bibwewadi Pune. Flexible booking options allow convenient Bibwewadi Urbania reservations."
  },
  {
    name: "14 Seater Urbania Pimpri",
    description: "14 seater Urbania Pimpri service provides spacious transportation for airport transfers, educational tours, office outings, and family group travel. Comfortable seating and luggage space ensure pleasant journeys suitable for medium-sized passenger groups. Professional drivers ensure safe transportation and punctual pickup services throughout the route. Pickup services are available from homes, schools, offices, and residential areas across Pimpri Pune. Flexible booking options allow convenient Pimpri Urbania reservations."
  },
  {
    name: "14 Seater Urbania Chinchwad",
    description: "14 seater Urbania Chinchwad service offers dependable transportation for family vacations, office travel, airport transfers, and sightseeing journeys. Spacious seating and premium interiors ensure smooth journeys suitable for local and outstation travel requirements. Professional chauffeurs ensure dependable transportation and safe driving services throughout the route. Pickup services are available from homes, offices, hotels, and residential areas across Chinchwad Pune. Flexible booking options allow convenient Chinchwad Urbania reservations."
  },
  {
    name: "14 Seater Urbania Hinjewadi",
    description: "14 seater Urbania Hinjewadi service provides reliable transportation for IT employees, office commute, airport transfers, and corporate group travel. Comfortable seating and spacious interiors ensure pleasant journeys suitable for business passenger groups. Professional chauffeurs ensure punctual transportation and safe driving services throughout the route. Pickup services are available from offices, IT parks, hotels, and residential areas across Hinjewadi Pune. Flexible booking options allow convenient Hinjewadi Urbania reservations."
  },
  {
    name: "14 Seater Urbania Wakad",
    description: "14 seater Urbania Wakad service offers spacious transportation for office travel, sightseeing journeys, airport transfers, and family group travel. Comfortable seating and smooth travel ensure pleasant journeys suitable for local and outstation transportation requirements. Professional chauffeurs ensure dependable transportation and safe driving services throughout the route. Pickup services are available from homes, hotels, offices, and residential areas across Wakad Pune. Flexible booking options allow convenient Wakad Urbania reservations."
  },
  {
    name: "14 Seater Urbania Nigdi / Akurdi",
    description: "14 seater Urbania Nigdi Akurdi service provides dependable transportation for family outings, office travel, airport transfers, and group travel requirements. Spacious interiors and comfortable seating ensure smooth journeys suitable for local and outstation passenger movement. Professional drivers ensure safe transportation and punctual pickup services throughout the route. Pickup services are available from homes, offices, hotels, and residential areas across Nigdi and Akurdi Pune. Flexible booking options allow convenient Nigdi Akurdi Urbania reservations."
  },
  {
    name: "14 Seater Urbania Ravet",
    description: "14 seater Urbania Ravet service offers luxury transportation for airport pickups, sightseeing tours, business travel, and family vacations. Comfortable seating and luggage space ensure pleasant journeys suitable for medium-sized passenger groups. Professional chauffeurs ensure dependable transportation and safe driving services throughout the route. Pickup services are available from homes, offices, hotels, and residential areas across Ravet Pune. Flexible booking options allow convenient Ravet Urbania reservations."
  },
  {
    name: "14 Seater Urbania for Wedding in Pune",
    description: "14 seater Urbania for wedding in Pune service provides elegant transportation for marriage ceremonies, bridal travel, guest transportation, and family functions. Spacious seating and premium interiors ensure comfortable journeys suitable for wedding celebrations and event transportation. Professional chauffeurs ensure punctual pickup and dependable transportation services throughout the wedding itinerary. Pickup services are available from homes, banquet halls, hotels, and residential areas across Pune. Flexible booking options allow convenient wedding Urbania reservations."
  },
  {
    name: "14 Seater Urbania for Corporate Events Pune",
    description: "14 seater Urbania for corporate events Pune service offers premium transportation for office events, conferences, employee outings, exhibitions, and executive travel requirements. Spacious interiors and modern seating ensure pleasant journeys suitable for local and outstation corporate transportation. Professional chauffeurs ensure punctual transportation and dependable pickup services throughout the route. Pickup services are available from offices, commercial hubs, hotels, and airports across Pune. Flexible booking options allow convenient corporate event Urbania reservations."
  },
  {
    name: "14 Seater Urbania for School Picnic Pune",
    description: "14 seater Urbania for school picnic Pune service provides safe and comfortable transportation for student outings, educational tours, school picnics, and group travel requirements. Spacious seating and smooth travel ensure pleasant journeys suitable for students, teachers, and school staff. Professional chauffeurs ensure dependable transportation and safe driving services throughout the route. Pickup services are available from schools, homes, and educational institutions across Pune. Flexible booking options allow convenient school picnic Urbania reservations."
  },
  {
    name: "14 Seater Urbania for Airport Pickup Pune",
    description: "14 seater Urbania for airport pickup Pune service provides dependable transportation for airport transfers, tourist groups, business travelers, and family travel requirements. Spacious seating and luggage space ensure comfortable journeys suitable for local and outstation airport transportation. Professional chauffeurs ensure timely airport pickups and safe driving services throughout the route. Pickup services are available from Pune Airport, homes, offices, hotels, and residential areas across Pune. Flexible booking options allow convenient airport Urbania reservations."
  },
  {
    name: "14 Seater Urbania for Pilgrimage Tour Pune",
    description: "14 seater Urbania for pilgrimage tour Pune service offers comfortable transportation for temple visits, Jyotirlinga tours, spiritual journeys, and family pilgrimage travel. Spacious seating and smooth highway travel ensure pleasant journeys suitable for long-distance religious tours. Professional chauffeurs ensure safe transportation and dependable pickup services throughout the route. Pickup services are available from homes, hotels, temples, and residential areas across Pune. Flexible booking options allow convenient pilgrimage Urbania reservations."
  },
  {
    name: "14 Seater Urbania for Family Group Travel Pune",
    description: "14 seater Urbania for family group travel Pune service provides spacious transportation for holiday vacations, sightseeing tours, pilgrimage journeys, and family outings. Comfortable seating and premium interiors ensure pleasant journeys suitable for local and outstation family travel requirements. Professional chauffeurs ensure reliable transportation and safe driving services throughout the route. Pickup services are available from homes, hotels, offices, and residential areas across Pune. Flexible booking options allow convenient family group Urbania reservations."
  },
  {
    name: "14 Seater Urbania for Outstation Tour Pune",
    description: "14 seater Urbania for outstation tour Pune service provides dependable long-distance transportation for Goa tours, hill station vacations, sightseeing journeys, and tourist travel. Spacious seating and smooth highway travel ensure comfortable journeys suitable for all passenger groups. Professional chauffeurs ensure safe transportation and reliable pickup services throughout the route. Pickup services are available from homes, offices, hotels, airports, and residential areas across Pune. Flexible booking options allow convenient outstation tour Urbania reservations."
  }
],

tableData: [
  ["14 Seater Urbania Traveller Pune", "14 Seater Urbania Hire in Pune"],
  ["14 Seater Urbania Booking Pune", "14 Seater Urbania Van Rental Pune"],
  ["Luxury 14 Seater Urbania on Rent Pune", "14 Seater Urbania for Outstation Pune"],
  ["14 Seater Urbania Near Me Pune", "14 Seater Urbania for Family Trip Pune"],
  ["14 Seater Urbania for Group Travel Pune", "14 Seater Urbania on Rent Hadapsar"],
  ["14 Seater Urbania Kharadi", "14 Seater Urbania Viman Nagar"],
  ["14 Seater Urbania Swargate", "14 Seater Urbania Kothrud"],
  ["14 Seater Urbania Camp Pune", "14 Seater Urbania Bibwewadi"],
  ["14 Seater Urbania Pimpri", "14 Seater Urbania Chinchwad"],
  ["14 Seater Urbania Hinjewadi", "14 Seater Urbania Wakad"],
  ["14 Seater Urbania Nigdi / Akurdi", "14 Seater Urbania Ravet"],
  ["14 Seater Urbania for Wedding in Pune", "14 Seater Urbania for Corporate Events Pune"],
  ["14 Seater Urbania for School Picnic Pune", "14 Seater Urbania for Airport Pickup Pune"],
  ["14 Seater Urbania for Pilgrimage Tour Pune", "14 Seater Urbania for Family Group Travel Pune"],
  ["14 Seater Urbania for Outstation Tour Pune", "14 Seater Urbania Traveller Pune"]
],





 whychoose: [
      {
        WhyChooseheading: "Reliable 14 Seater Urbania on Rent in Pune",
        WhyChoosedescription: "Aaradhya Travels provides reliable 14 seater Urbania rental service in Pune with luxury vehicles, professional drivers, and smooth travel arrangements for family trips, corporate tours, weddings, and group travel."
      },
      {
        WhyChooseheading: "Affordable 14 Seater Urbania Rental Packages",
        WhyChoosedescription: "Aaradhya Travels offers affordable 14 seater Urbania on rent in Pune with transparent pricing, flexible booking plans, and complete travel support without hidden charges."
      },
      {
        WhyChooseheading: "24/7 Urbania Booking Service",
        WhyChoosedescription: "Our 14 seater Force Urbania rental service in Pune operates 24 hours for airport transfers, weddings, outstation tours, pilgrimage trips, corporate outings, and luxury group travel."
      },
      {
        WhyChooseheading: "Comfortable AC Luxury Urbania Vehicles",
        WhyChoosedescription: "All 14 seater Force Urbania vehicles provided by Aaradhya Travels are spacious, air-conditioned, clean, and regularly maintained for premium and comfortable group travel experiences."
      },
      {
        WhyChooseheading: "One Day & Multi-Day Tour Packages",
        WhyChoosedescription: "Aaradhya Travels offers customized one-day trips, weekend tours, pilgrimage journeys, sightseeing travel, and multi-day outstation packages according to customer requirements."
      },
      {
        WhyChooseheading: "Perfect for Family & Corporate Group Travel",
        WhyChoosedescription: "Our 14 seater Urbania is ideal for family vacations, office outings, wedding guest transport, airport transfers, picnic tours, and tourist group travel."
      },
      {
        WhyChooseheading: "Pickup Available Across Pune City",
        WhyChoosedescription: "Aaradhya Travels provides convenient pickup from Baner, Wakad, Hinjewadi, Kharadi, Hadapsar, Viman Nagar, Pune Airport, railway stations, hotels, and all major Pune locations."
      },
      {
        WhyChooseheading: "Experienced Drivers for Safe Outstation Travel",
        WhyChoosedescription: "Our experienced drivers ensure safe driving, smooth highway journeys, and timely travel for local sightseeing and outstation luxury group transportation requirements."
      }
    ]
  };

  const faqData = [
    { question: "What is 14 seater Urbania on rent in Pune?", answer: "14 seater Urbania rental service in Pune provides luxury group transportation using premium Force Urbania vehicles for family tours, corporate travel, weddings, and outstation journeys." },
    { question: "Is 14 seater Urbania booking available 24 hours in Pune?", answer: "Yes, Aaradhya Travels provides 24/7 14 seater Force Urbania rental service in Pune." },
    { question: "Is the 14 seater Urbania fully air-conditioned?", answer: "Yes, all 14 seater Force Urbania vehicles are fully air-conditioned and maintained for comfortable luxury travel." },
    { question: "Can I book 14 seater Urbania for outstation trips from Pune?", answer: "Yes, customers can book 14 seater Force Urbania for hill stations, pilgrimage tours, holiday trips, destination weddings, and outstation travel from Pune." },
    { question: "Do you provide 14 seater Urbania for corporate events in Pune?", answer: "Yes, Aaradhya Travels provides 14 seater Force Urbania service for office outings, conferences, employee transport, and corporate travel." },
    { question: "Can I book Urbania for weddings and family functions?", answer: "Yes, our 14 seater Urbania vehicles are ideal for wedding guest transportation and family group travel." },
    { question: "Can I book 14 seater Urbania online in Pune?", answer: "Yes, customers can easily book 14 seater Force Urbania rental service online or through phone booking." },
    { question: "Do you provide Pune Airport pickup and drop service?", answer: "Yes, Aaradhya Travels provides airport pickup and drop service using luxury 14 seater Force Urbania vehicles." },
    { question: "Are Urbania rental charges transparent?", answer: "Yes, Aaradhya Travels provides affordable and transparent pricing without hidden charges." },
    { question: "Is advance booking available for 14 seater Urbania rental service?", answer: "Yes, advance booking is available and recommended during weekends, holidays, wedding seasons, and peak travel periods." }
  ];

const testimonials = [
  {
    id: 1,
    name: "Mr. Kunal Jadhav",
    feedback:
      "For our corporate outing, we chose an Urbania on rent in Pune and were impressed with the premium interiors and comfortable seating. The trip was enjoyable from start to finish.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Rutuja Pawar",
    feedback:
      "Traveling with a large family became hassle-free thanks to the Urbania rental service in Pune. The vehicle was spacious, well-maintained, and provided a relaxing journey throughout.",
    rating: 5
  }
];


  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "Tempo-Traveller-On-Rent-in-Pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Mahabaleshwar Tempo Traveller", link: "Pune-to-Mahabaleshwar-Tempo-Traveller" },
    { place: "/images/keyword/3.jpg", text: "Pune to Outstation Tempo Traveller", link: "Pune-to-Outstation-Tempo-Traveller" },
    { place: "/images/keyword/4.jpg", text: "Mini Bus On Rent in Pune", link: "Mini-Bus-On-Rent-in-Pune" },
    { place: "/images/keyword/5.jpg", text: "Outstation Mini Bus on Rent Pune", link: "Outstation-Mini-Bus-on-Rent-Pune" },
    { place: "/images/keyword/6.jpg", text: "14 Seater Tempo Traveller on Rent in Pune", link: "14-Seater-Tempo-Traveller-on-Rent-in-Pune" },
    { place: "/images/keyword/7.jpg", text: "17 Seater Bus on Rent in Pune", link: "17-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/8.jpg", text: "Pune to Shirdi Tempo Traveller", link: "Pune-to-Shirdi-Tempo-Traveller" },
    { place: "/images/keyword/9.jpg", text: "20 Seater Bus on Rent in Pune", link: "20-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/10.jpg", text: "25 Seater Tempo Traveller on Rent in Pune", link: "25-Seater-Tempo-Traveller-on-Rent-in-Pune" },
    { place: "/images/keyword/11.jpg", text: "Tempo Traveller on Rent in Pimpri Chinchwad", link: "Tempo-Traveller-on-Rent-in-Pimpri-Chinchwad" },
    { place: "/images/keyword/12.jpg", text: "32 Seater Bus Rent in Pune", link: "32-Seater-Bus-Rent-in-Pune" },
    { place: "/images/keyword/13.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/14.jpg", text: "45 Seater Bus on Rent in Pune", link: "45-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/15.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-Seater-Bus-On-Rent-in-Pune" },
    { place: "/images/keyword/16.jpg", text: "Non AC Bus Rental Service in Pune", link: "Non-AC-Bus-Rental-Service-in-Pune" },
    { place: "/images/keyword/17.jpg", text: "Luxury Bus Rental in Pune", link: "Luxury-Bus-Rental-in-Pune" },
    { place: "/images/keyword/18.jpg", text: "Luxury Force Urbania On Rent in Pune", link: "Luxury-Force-Urbania-On-Rent-in-Pune" },
    { place: "/images/keyword/19.jpg", text: "Force Urbania Luxury Mini Bus On Rent", link: "Force-Urbania-Luxury-Mini-Bus-On-Rent" },
    { place: "/images/keyword/20.jpg", text: "Mini Bus On Rent in Pune", link: "Mini-Bus-On-Rent-in-Pune-2" },
    { place: "/images/keyword/21.jpg", text: "14 17 20 25 Seater Bus on Rent in Pune", link: "14-17-20-25-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/22.jpg", text: "Travel Agents in Pune for Mini Bus Hire", link: "Travel-Agents-in-Pune-for-Mini-Bus-Hire" },
    { place: "/images/keyword/23.jpg", text: "Tempo Traveller Hire in Pune", link: "Tempo-Traveller-Hire-in-Pune" },
  ];








const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "14 Seater Urbania on Rent in Pune",
  "image": "https://www.aaradhyatravels99.com/assets/images/14-seater-urbania-pune.jpg",
  "description": "Book 14 Seater Urbania on rent in Pune with Aaradhya Travels for luxury group travel, corporate trips, weddings, airport transfers, family trips, and outstation journeys. Premium AC luxury van available across Pune including Hadapsar, Kharadi, Viman Nagar, and Swargate.",
  "brand": {
    "@type": "Brand",
    "name": "Aaradhya Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "12160"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "On Request",
    "availability": "https://schema.org/InStock",
    "url": "https://www.aaradhyatravels99.com/14-seater-urbania-on-rent-in-pune"
  }
};






  return (
    <div>


<Helmet>
  <title>
    14 Seater Urbania on Rent in Pune | Luxury Group Travel Van | +91 9529697070
  </title>

  <meta
    name="description"
    content="Hire 14 Seater Urbania on rent in Pune with Aaradhya Travels. Perfect for family trips, corporate travel, weddings, airport pickup, and outstation journeys. Available across Hadapsar, Kharadi, Viman Nagar, and Swargate."
  />

  <meta
    name="keywords"
    content="14 Seater Urbania Traveller Pune,14 Seater Urbania Hire in Pune,14 Seater Urbania Booking Pune,14 Seater Urbania Van Rental Pune,Luxury 14 Seater Urbania on Rent Pune,14 Seater Urbania for Outstation Pune,14 Seater Urbania Near Me Pune,14 Seater Urbania for Family Trip Pune,14 Seater Urbania for Group Travel Pune,14 Seater Urbania on Rent Hadapsar,14 Seater Urbania Kharadi,14 Seater Urbania Viman Nagar,14 Seater Urbania Swargate"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1
                  className="text-anime-style-3 text-center text-white"
                  data-cursor="-opaque"
                >
                  {cardData.keyword}
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>
















      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/87.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#FFB100', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Aaradhya Travels: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    {/* <div className="service-icon">
                      🚗
                    </div> */}
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Aaradhya Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Aaradhya Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


               <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919529697070" className="pc-call">+91 9529697070</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919529697070"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+919529697070" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@aaradhyatravels99.com" className="pc-email">
                      booking@aaradhyatravels99.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-geo-alt-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Aaradhya Travels</strong><br />
                      Near RMD College, Opp. Chaudhary Parking, Warje, Pune - 411058
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Onefourseaterurbania ;